export const MAX_KEYWORDS = 100;

export const normalizeKeyword = (keyword) => String(keyword ?? "").trim();

export const parseKeywordInput = (text) =>
    String(text ?? "")
        .split(/[,\n]/)
        .map(normalizeKeyword)
        .filter(Boolean);

// Case-insensitive dedupe, keeps the casing of the first occurrence.
export const dedupeKeywords = (keywords = []) => {
    const seen = new Set();
    const unique = [];
    for (const raw of keywords) {
        const keyword = normalizeKeyword(raw);
        if (!keyword) continue;
        const key = keyword.toLowerCase();
        if (seen.has(key)) continue;
        seen.add(key);
        unique.push(keyword);
    }
    return unique;
};

// Merges scopes in priority order, dedupes, caps at max.
// Returns per-scope kept/dropped counts so the UI can warn precisely.
export const resolveEffectiveKeywords = (scopes = [], max = MAX_KEYWORDS) => {
    const seen = new Set();
    const merged = [];
    const perScope = [];

    for (const scope of scopes) {
        let kept = 0;
        const droppedKeywords = [];
        for (const raw of scope?.keywords || []) {
            const keyword = normalizeKeyword(raw);
            if (!keyword) continue;
            const key = keyword.toLowerCase();
            if (seen.has(key)) continue;
            if (merged.length >= max) {
                droppedKeywords.push(keyword);
                continue;
            }
            seen.add(key);
            merged.push(keyword);
            kept += 1;
        }
        perScope.push({
            label: scope?.label,
            kept,
            dropped: droppedKeywords.length,
            droppedKeywords,
        });
    }

    return {
        merged,
        scopes: perScope,
        droppedTotal: perScope.reduce((sum, scope) => sum + scope.dropped, 0),
    };
};
